var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEmisorPodcasting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.464,
    height: 29.34,
    viewBox: "0 0 98.464 29.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1103 -458.83)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4928.72 1510.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3778.762-1044.027v-2.3h-8.8v11.039h8.954v-2.472h-6.078v-2.1h5.412v-2.226h-5.412v-1.935Z",
    transform: "translate(-0.111 -0.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3720.481-998.561a1.19,1.19,0,0,1,1.322,1.009h1.7a2.8,2.8,0,0,0-2.99-2.478,3.225,3.225,0,0,0-3.266,3.413,3.225,3.225,0,0,0,3.266,3.413,2.764,2.764,0,0,0,2.99-2.677h-1.7a1.216,1.216,0,0,1-1.322,1.211c-1.1,0-1.524-.972-1.524-1.944S-3721.582-998.561-3720.481-998.561Z",
    transform: "translate(-44.382 -32.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.876,
    height: 11.039,
    transform: "translate(-3763.379 -1046.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3742.335-999.57h-2.815v6.55h2.815a2.966,2.966,0,0,0,3.21-3.3A2.971,2.971,0,0,0-3742.335-999.57Zm-.3,5.081h-.806V-998.1h.806a1.591,1.591,0,0,1,1.806,1.769C-3740.83-995.022-3741.345-994.517-3742.639-994.489Z",
    transform: "translate(-29.516 -32.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3765.411-1000.02a3.15,3.15,0,0,0-3.229,3.413,3.15,3.15,0,0,0,3.229,3.413,3.15,3.15,0,0,0,3.229-3.413A3.147,3.147,0,0,0-3765.411-1000.02Zm0,5.357c-1.1,0-1.524-.972-1.524-1.944s.423-1.944,1.524-1.944,1.524.972,1.524,1.944S-3764.31-994.663-3765.411-994.663Z",
    transform: "translate(-13.229 -32.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3741.671-1035.291v-11.039h-4.235l-1.9,7.359h-.03l-1.9-7.359h-4.238v11.039h2.708v-8.38h.031l2.318,8.38h2.2l2.321-8.38h.031v8.38Z",
    transform: "translate(-23.394 -0.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3784.611-999.57h-3.109v6.55h1.7V-995.2h1.4c1.441,0,2.367-.632,2.367-2.257C-3782.243-999.012-3783.39-999.57-3784.611-999.57Zm-.258,3.045h-1.147V-998.2h1.147a.806.806,0,0,1,.917.862C-3783.951-996.746-3784.334-996.525-3784.868-996.525Z",
    transform: "translate(0 -32.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3651.314-1041.337c0-3.2-1.963-5.753-5.443-5.753s-5.443,2.551-5.443,5.753,1.962,5.753,5.443,5.753S-3651.314-1038.136-3651.314-1041.337Zm-8.01,0c0-1.641.711-3.278,2.567-3.278s2.566,1.637,2.566,3.278-.711,3.278-2.566,3.278S-3659.324-1039.7-3659.324-1041.337Z",
    transform: "translate(-87.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3609.218-995.653h1.193c-.092.595-.659.99-1.506.99-1.1,0-1.524-.972-1.524-1.944s.423-1.944,1.524-1.944c.687,0,1.239.34,1.294.9h1.7a2.741,2.741,0,0,0-2.962-2.367,3.225,3.225,0,0,0-3.266,3.413,3.225,3.225,0,0,0,3.266,3.413,2.233,2.233,0,0,0,1.825-.852l.1.714h1.1v-3.588h-2.751v1.266Z",
    transform: "translate(-121.31 -32.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3614.849-1040.431v-.031a2.839,2.839,0,0,0,1.733-2.769c0-2.226-1.917-3.109-3.867-3.109h-5.627v11.039h2.876v-4.02h2.18c1.346,0,1.53,1.144,1.607,2.257a5.312,5.312,0,0,0,.325,1.763h2.846c-.386-.4-.432-2.027-.463-2.49C-3613.334-1038.836-3613.675-1040.152-3614.849-1040.431Zm-2.475-1.113h-2.413v-2.49h2.288c.8,0,1.453.371,1.453,1.19A1.182,1.182,0,0,1-3617.324-1041.544Z",
    transform: "translate(-114.48 -0.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3629.535-995.535h-.015l-2.275-4.035h-1.754v6.55h1.607V-997.1h.018l2.275,4.084h1.751v-6.55h-1.607Z",
    transform: "translate(-106.874 -32.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.705,
    height: 6.55,
    transform: "translate(-3743.14 -1032.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3677.917-997.286c-.954-.267-1.9-.359-1.9-.862,0-.432.46-.561.825-.561.521,0,1.083.193,1.055.788h1.705c-.009-1.478-1.322-2.11-2.625-2.11-1.229,0-2.671.558-2.671,1.99,0,1.2.981,1.622,1.917,1.889s1.88.377,1.88.954c0,.488-.534.669-1.046.669-.724,0-1.2-.248-1.239-1.018h-1.7c.009,1.677,1.34,2.34,2.843,2.34,1.441,0,2.852-.534,2.852-2.192C-3676.02-996.577-3676.973-997.019-3677.917-997.286Z",
    transform: "translate(-73.496 -32.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3690.576-1037.811c-1.22,0-2.027-.417-2.088-1.717h-2.876c.015,2.83,2.257,3.943,4.793,3.943,2.428,0,4.808-.9,4.808-3.7,0-1.993-1.607-2.738-3.2-3.186s-3.2-.6-3.2-1.453c0-.727.773-.944,1.392-.944.88,0,1.825.325,1.779,1.331h2.876c-.015-2.49-2.226-3.557-4.422-3.557-2.073,0-4.5.944-4.5,3.355,0,2.027,1.656,2.738,3.232,3.186,1.591.448,3.171.635,3.171,1.607C-3688.812-1038.121-3689.708-1037.811-3690.576-1037.811Z",
    transform: "translate(-63.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3700.68-999.57l-2.45,6.55h1.751l.414-1.174h2.284l.4,1.174h1.779l-2.45-6.55Zm.11,4.109.742-2.294h.018l.724,2.294Z",
    transform: "translate(-58.651 -32.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3662.5-998.1h1.953v5.084h1.705V-998.1h1.953v-1.466h-5.611Z",
    transform: "translate(-86.822 -32.948)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1101.59 457.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.41 1.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.604,
    height: 5.867,
    transform: "translate(0 11.736)",
    fill: "#ba007c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41,163.824A1.193,1.193,0,0,0,2.6,165.017H29.555a1.193,1.193,0,0,0,1.193-1.193V159.15H1.41Z",
    transform: "translate(-1.41 -135.677)",
    fill: "#feee00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.565,1.41H2.613A1.193,1.193,0,0,0,1.42,2.6V7.277H30.76V2.6A1.2,1.2,0,0,0,29.565,1.41Z",
    transform: "translate(-1.419 -1.41)",
    fill: "#00bcff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmisorPodcasting);
export default __webpack_public_path__ + "static/media/logo-emisor-podcasting.4d0e1b8c47d61ce54280e8e1723f228e.svg";
export { ForwardRef as ReactComponent };